export default "__VITE_ASSET__BfSSPR39__"